module.exports = __webpack_public_path__ + "img/r_figure_01.00de0f03.png";